import { observer } from 'mobx-react-lite';
import { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Button, Grid, Icon } from 'semantic-ui-react';
import agent from '../../../app/api/agent';
import LoadingComponent, {
  LoadingComponent2,
} from '../../../app/layout/LoadingComponent';
import { useStore } from '../../../app/stores/store';
import ActivityDetailedChat from './ActivityDetailedChat';
import ActivityDetailedHeader from './ActivityDetailedHeader';
import ActivityDetailedInfo from './ActivityDetailedInfo';
import ActivityDetailedSideBar from './ActivityDetailedSideBar';
import ActivityUser from './ActivityUser';

export default observer(function ActivityDetails() {
  const {
    activityStore,
    commonStore,
    viewStore: { getAssignedUsers, getActiveOrder },
    userStore,
  } = useStore();

  const {
    selectedActivity: activity,
    loadingInitial,
    loadingInitialSections,
    loadSectionsData,
  } = activityStore;

  const { id } = useParams<{ id: string }>();
  const history = useNavigate();

  const isOpen = useRef(false);

  useEffect(() => {
    (async () => {
      if (id) {
        let result = await agent.MetaDataAssetTypes.searchisMasterAPI(id);
        if (result) {
          history(`/mastersreport/${result}`);
          // setIsMaster(result);
        }
      }
    })();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (id) {
      activityStore.loadActivity(id);
      getActiveOrder({ itemId: id });
      if (
        userStore.user?.customerName !== 'NFAI' ||
        window.innerWidth > 1025 ||
        window.innerWidth < 1020
      ) {
        getAssignedUsers({ itemId: id });
      }
    }
    // eslint-disable-next-line
  }, [id]);

  const openChat = () => {
    const chatElement = document.getElementById(
      'chat-mobile',
    ) as HTMLDivElement;
    if (!isOpen.current) {
      chatElement?.classList.add('show');
    } else {
      chatElement?.classList.remove('show');
    }
    isOpen.current = !isOpen.current;
  };

  if (loadingInitial || !activity) return <LoadingComponent />;
  if (loadingInitialSections || !activity)
    return <LoadingComponent2 datas={loadSectionsData} />;
  return (
    <div>
      <Grid className="activity-details-mobile">
        <Grid.Row
          style={{
            height:
              commonStore.filterModeTwo?.includes('AVLAVD03') &&
              commonStore.filterModeTwo?.includes('AVLAVB11') &&
              commonStore.filterModeTwo?.includes('AVLAVD02') &&
              window.innerWidth > 1200
                ? 'calc(100vh - 100px)'
                : 'calc(90vh - 10px)',
          }}
        >
          <Grid.Column
            width={
              window.innerWidth < 1200 ||
              commonStore.filterModeTwo?.includes('AVLAVD01')
                ? 16
                : 10
            }
            className="view-item-details"
          >
            <ActivityDetailedHeader activity={activity} />
          </Grid.Column>
          <Grid.Column width={window.innerWidth < 1200 ? 16 : 6}>
            {commonStore.filterModeTwo?.includes('AVLAVD01') ? (
              <></>
            ) : (
              <div
                className={
                  commonStore.filterModeZero?.includes('AVLAVD01')
                    ? 'component-isDisabled adh-sidebar-metadata'
                    : 'adh-sidebar-metadata'
                }
              >
                <ActivityDetailedSideBar
                  actId={activity?.id}
                  title={activity?.title}
                  elementType={activity?.element}
                />
              </div>
            )}
          </Grid.Column>
        </Grid.Row>
        {(userStore.user?.customerName !== 'NFAI' ||
          window.innerWidth > 1025 ||
          window.innerWidth < 1020) && (
          <Grid.Row>
            <Grid.Column width={window.innerWidth < 1200 ? 16 : 10}>
              <Grid>
                <Grid.Row>
                  <Grid.Column
                    width={
                      commonStore.filterModeTwo?.includes('AVLAVD02') ? 16 : 8
                    }
                    style={{
                      paddingRight: !commonStore.filterModeTwo?.includes(
                        'AVLAVD02',
                      )
                        ? '0px'
                        : '1rem',
                    }}
                  >
                    {commonStore.filterModeTwo?.includes('AVLAVD03') ? (
                      <></>
                    ) : (
                      <ActivityDetailedInfo />
                    )}
                  </Grid.Column>
                  <Grid.Column
                    width={
                      window.innerWidth < 767 ||
                      commonStore.filterModeTwo?.includes('AVLAVD03')
                        ? 16
                        : 8
                    }
                  >
                    {commonStore.filterModeTwo?.includes('AVLAVD02') ? (
                      <></>
                    ) : (
                      <ActivityUser />
                    )}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            {commonStore.filterModeTwo?.includes('AVLAVB11') ? (
              <></>
            ) : (
              <Grid.Column width={window.innerWidth < 1200 ? 16 : 6}>
                <ActivityDetailedChat
                  isOpen={isOpen}
                  activityId={activity.id}
                />
                <Button
                  color="yellow"
                  id="chat-mobile-btn"
                  onClick={openChat}
                  className={
                    commonStore.filterModeZero?.includes('AVLAVB11')
                      ? 'component-isDisabled'
                      : ''
                  }
                >
                  <Icon name="chat" color="teal" size="large" /> Chat
                </Button>
              </Grid.Column>
            )}
          </Grid.Row>
        )}
      </Grid>
    </div>
  );
});
